import { Navigate } from "react-router-dom";

const AuthRedirect = ({ children }) => {
  const isAuthenticated = Boolean(
    localStorage.getItem("access_token")
  );

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AuthRedirect;
